// history ページの decade-bar スクロール連動
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn"]

  connect() {
    this.#bindScroll()
  }

  disconnect() {
    if (this._onScroll) window.removeEventListener("scroll", this._onScroll)
  }

  scroll(event) {
    const target = document.getElementById(event.currentTarget.dataset.target)
    if (target) window.scrollTo({ top: target.offsetTop - 60, behavior: "smooth" })
  }

  #bindScroll() {
    const eras = document.querySelectorAll(".era-block")
    const btns = this.btnTargets
    this._onScroll = () => {
      let active = 0
      eras.forEach((e, i) => { if (e.getBoundingClientRect().top < innerHeight * 0.5) active = i })
      btns.forEach((b, i) => b.classList.toggle("active", i === active))
    }
    window.addEventListener("scroll", this._onScroll, { passive: true })
  }
}
